export const SECURITY_CONFIG = {
  cors: {
    allowedOrigins: [
      import.meta.env.VITE_APP_URL || 'http://localhost:5173',
      'https://scalesmall.ai',
      'https://www.scalesmall.ai',
    ],
    allowedMethods: ['GET', 'POST', 'PUT', 'DELETE', 'OPTIONS', 'PATCH'],
    allowedHeaders: [
      'Content-Type',
      'Authorization',
      'X-Client-Info',
      'apikey',
      'Prefer',
      'Range'
    ],
    credentials: true,
    maxAge: 86400
  },
  rateLimit: {
    auth: {
      maxAttempts: 5,
      windowMs: 15 * 60 * 1000,
      blockDurationMs: 15 * 60 * 1000
    },
    api: {
      maxRequests: 100,
      windowMs: 15 * 60 * 1000
    }
  },
  password: {
    minLength: 8,
    requireUppercase: true,
    requireLowercase: true,
    requireNumbers: true,
    requireSpecialChars: true
  },
  session: {
    maxAge: 24 * 60 * 60 * 1000,
    inactivityTimeout: 30 * 60 * 1000
  }
};

export const validateOrigin = (origin: string | undefined): boolean => {
  if (!origin) return false;

  const isDevelopment = import.meta.env.DEV;
  if (isDevelopment && origin.startsWith('http://localhost')) {
    return true;
  }

  return SECURITY_CONFIG.cors.allowedOrigins.some(allowed =>
    origin === allowed || origin.endsWith(allowed)
  );
};

export const getCorsHeaders = (origin: string | undefined) => {
  const isValidOrigin = validateOrigin(origin);

  return {
    'Access-Control-Allow-Origin': isValidOrigin ? (origin || SECURITY_CONFIG.cors.allowedOrigins[0]) : SECURITY_CONFIG.cors.allowedOrigins[0],
    'Access-Control-Allow-Methods': SECURITY_CONFIG.cors.allowedMethods.join(', '),
    'Access-Control-Allow-Headers': SECURITY_CONFIG.cors.allowedHeaders.join(', '),
    'Access-Control-Allow-Credentials': SECURITY_CONFIG.cors.credentials ? 'true' : 'false',
    'Access-Control-Max-Age': SECURITY_CONFIG.cors.maxAge.toString()
  };
};
